const DESKTOP_STANDARD_WIDTH = 400;
const VIEW_GAP = 10;
const DESKTOP_HORIZONTAL_PADDING = 80;
const DESKTOP_VERTICAL_PADDING = 80;
const MOBILE_BREAKPOINT = 640;
const MOBILE_HORIZONTAL_PADDING = 0;
const MOBILE_VERTICAL_PADDING = 60;

export function getViewGap(): number {
  return VIEW_GAP;
}

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

export function getHorizontalPadding(): number {
  return isMobileViewport() ? MOBILE_HORIZONTAL_PADDING : DESKTOP_HORIZONTAL_PADDING;
}

export function getContainerPadding(): number {
  return getHorizontalPadding();
}

export function getVerticalPadding(): number {
  return isMobileViewport() ? MOBILE_VERTICAL_PADDING : DESKTOP_VERTICAL_PADDING;
}

export function getStandardViewWidth(): number {
  if (typeof window === 'undefined') {
    return DESKTOP_STANDARD_WIDTH;
  }
  if (isMobileViewport()) {
    const padding = getHorizontalPadding();
    const width = window.innerWidth - (padding * 2);
    return Math.max(width, 0);
  }
  return DESKTOP_STANDARD_WIDTH;
}

export function getDoubleViewWidth(): number {
  return isMobileViewport() ? getStandardViewWidth() : DESKTOP_STANDARD_WIDTH * 2;
}

export function getAvailableHeight(): number {
  if (typeof window === 'undefined') {
    return 300;
  }
  const padding = getVerticalPadding();
  return window.innerHeight - (padding * 2);
}

